import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;

const EducationCollab = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX']}}>Collaborations</Paragraph>
        <Text className='BaseText2'>Throughout this season, we collaborated with other iGEM teams in order to <b>share ideas, learn from one another and team up to create projects and spaces to encourage science communication</b>. The iMoAge team&apos;s education area successfully participated in the following collaborations:</Text>
        <Content align='center' style={{justifyContent: 'space-evenly', marginLeft: 'auto', marginRight: 'auto', width: '100%', display: 'block', marginTop: '7%', background: 'inherit'}}>
          <Paragraph className='BaseText' style={{color: appColors['ColorA'], textAlign: 'center', fontSize: '3.5vh', width: '50%', float: 'left', display: 'block'}}><b>iGEM AFCM<br/>Egypt</b></Paragraph>
          <Paragraph className='BaseText' style={{color: appColors['ColorA'], textAlign: 'center', fontSize: '3.5vh', width: '50%', float: 'right', display: 'block'}}><b>iGEM Tec<br/>CEM</b></Paragraph>
        </Content>
        <Paragraph className='Title4' style={{color: appColors['ColorBack'], marginTop: '3vh', textAlign: 'center', fontSize: '3.5vh'}}>If you want to learn about our collaborations we invite you to check our exclusive tab for this section: <a href='/tecccm/collaborations'><b><q>Collaborations</q></b></a> and <a href='/tecccm/partnership'><q><b>Partership</b></q></a></Paragraph>
        <Divider/>
      </Content>
    </Layout>
  );
};

export default EducationCollab;
